export const defaultOriginalFileParams = {
  fileName: '',
  candidateDocumentId: '',
};
